'use client'

import { ComponentProps, useMemo } from 'react'
import styled from 'styled-components'

import { OpenVideoModalTextButton } from '@syconium/little-miss-figgy/dist/components/OpenVideoModalTextButton'

import { NextDialogProvider, NextDialogTrigger } from '../dialogs/NextDialog.client'
import { NextVideoDialog } from '../dialogs/NextVideoDialog.client'

const PlayButton = styled.button`
  background: rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  box-shadow: 0 0 10px -5px black;
  height: 44px;
  position: relative;
  width: 44px;

  &::after {
    content: '';
    display: block;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 10px solid black;
    height: 0;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-36%, -50%);
    width: 0;
  }
`

type WatchVideoDialogProps = {
  videoId: string
  videoPlatform: 'vimeo' | 'youtube'
  text?: string | undefined | null
} & Omit<ComponentProps<'button'>, 'children' | 'text' | 'onClick'> & {
    render?: ComponentProps<typeof NextDialogTrigger>['render']
  }

export const WatchVideoDialog = ({
  videoId,
  videoPlatform,
  text,
  render: renderProp,
  ...buttonPassthroughProps
}: WatchVideoDialogProps) => {
  const defaultRender = useMemo<NonNullable<typeof renderProp>>(() => {
    return htmlProps => {
      return text ? (
        <OpenVideoModalTextButton text={text} {...htmlProps} {...buttonPassthroughProps} />
      ) : (
        <PlayButton {...htmlProps} {...buttonPassthroughProps} />
      )
    }
  }, [buttonPassthroughProps, text])

  return (
    <NextDialogProvider>
      <NextDialogTrigger render={renderProp ?? defaultRender} />
      <NextVideoDialog videoId={videoId} videoPlatform={videoPlatform} />
    </NextDialogProvider>
  )
}
